export { default, SlideoutModalCertificate } from './SlideoutModalCertificate';